import React, { useEffect, useState } from "react";

// Thin orange scroll-progress line; mobile only
export const MobileReadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? Math.min(1, window.scrollY / max) : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="absolute inset-x-0 -bottom-px h-[3px] md:hidden" data-testid="mobile-reading-progress">
      <div
        className="h-full origin-left bg-[#FF4500] transition-transform duration-150 ease-out"
        style={{ transform: `scaleX(${progress})` }}
        data-testid="mobile-reading-progress-bar"
      />
    </div>
  );
};

export default MobileReadingProgress;
